module.exports = "/assets/da0514e49f731720ab641745b4b24d77.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/0B.png
// module id = 2083
// module chunks = 0